export default __webpack_public_path__ + "static/seth-4f7e4cb860a92bd13e3e69c7bc9207dc.svg";